<template>
  <section>
    <Modal
      v-model:show="active" 
      :class="{ opacity: hiddenModal }" 
      class="offer media-tags" 
      @close="close"
    >
      <template v-slot:header>
        <h5 class="modal-title mt-8">
          {{ $t('mediaTags.genTag') }}
        </h5>
      </template>
      <!-- offer -->
      <div>
        <UiSelect
          v-if="hideSelect(offers)"
          v-model="offer"
          :label="$t('mediaTags.offer')"
          :placeholder="$t('promoCodes.addPromocodes.selectOffer')"
          :list="offers"
          is-search
          class="mb-16"
          @change="selectOffer"
        />
        <!-- brand -->
        <UiSelect
          v-if="active && hideSelect(brands, 'brand')"
          v-model="brand"
          :label="$t('mediaTags.brand')"
          :placeholder="$t('profile.generalInfo.notSpecified')"
          :list="brands"
          is-search
          class="mb-16"
          :disabled="offer === ''"
          @change="changeBrand"
        />
        <!-- rotation -->
        <UiSelect
          v-if="hideSelect(rotations)"
          v-model="rotation"
          :label="$t('mediaTags.rotation')"
          :placeholder="$t('profile.generalInfo.notSpecified')"
          :list="rotations"
          :disabled="brand === ''"
          class="mb-16"
          is-search
          @change="changeRotation"
        />
        <!-- target -->
        <UiSelect
          v-model="targetId"
          :label="$t('mediaTags.target')"
          :placeholder="$t('profile.generalInfo.notSpecified')"
          :list="urls"
          class="mb-16"
          is-search
          :disabled="rotation === ''"
          @change="selectTarget"
        />
        <div
          v-if="($store.state.media.mediacontent.language_codes || []).length > 1"
          class="db-wrap !tw-flex !tw-justify-between mb-16"
        >
          <!-- size -->
          <UiSelect
            v-if="type === 'html5_banner' || type === 'simple_banner'"
            v-model="size"
            :label="$t('mediaTags.size')"
            :placeholder="$t('profile.generalInfo.notSpecified')"
            :list="sizes"
            is-search
            class="w-full"
            :disabled="type === 'landing' || targetId === ''"
            @change="handlerSizes"
          />
          <!-- languages -->
          <div
            class="ml-16 w-full"
            :class="{'ml-0': type !== 'html5_banner' && type !== 'simple_banner'}"
          >
            <UiSelect
              v-model="language"
              :label="$t('mediaTags.languages')"
              :placeholder="$t('mediaTags.languagesAuto')"
              :list="languages"
              is-search
              :disabled="targetId === ''"
              @change="handlerLanguage"
            />
          </div>
        </div>
        <UiInput
          v-model="link"
          :label="$t('mediaTags.url')"
          :disabled="targetId === ''"
          class="mb-8"
          @input="inputLink"
        />
        <!-- tags -->
        <div class="tag-wrap mb-16">
          <span
            v-for="item in links"
            :key="item.page_url"
            :class="{ 'el-tag--selected': link === item.page_url, 'disabled-link': targetId === '' }"
            class="el-tag el-tag--primary el-tag--small"
            @click="setLink(item.page_url)"
          >{{ item.name }}</span>
        </div>
        <ElPopover
          ref="popover"
          v-model:visible="warningOpen"
          placement="top-end"
          trigger="click"
          width="320"
        >
          <p>{{ $t('promoCodes.addPromocodes.changeSubId') }}</p>
          <button
            class="btn btn-outline-primary btn-md"
            @click="saveSubids"
          >
            {{ $t('offerRequest.btnCancel') }}
          </button>
          <button
            class="btn btn-primary btn-md !tw-ml-1rem"
            @click="
              confirmChanges();
              warningOpen = false;
            "
          >
            {{ $t('offerRequest.btnConfirm') }}
          </button>
          <template v-slot:reference>
            <div />
          </template>
        </ElPopover>
        <!-- traffic sources -->
        <UiSelect
          v-if="type === 'landing' || 'html5_banner'"
          v-model="traffic_source_id"
          :label="$t('trafficSources.trafficSource')"
          :placeholder="$t('offerRequest.noTrafficSources')"
          :list="trafficSource"
          is-search
          :disabled="targetId === ''"
          class="mb-16"
          @change="
            checkChange = false;
            getUrlD();
          "
        />
        <!-- landing subids -->
        <div class="row row-wrap__subid">
          <div
            v-for="(item, i) in form.subids"
            :key="i"
            class="mb-16 col-6 col-6__add-subid"
          >
            <UiInputSubid
              v-model="item.value"
              :label="`SubID ${i + 1}`"
              :disabled="targetId === ''"
              :placeholder="$t('trafficSources.postbacks.notSpecified')"
              :can-delete="form.subids.indexOf(item) === form.subids.length - 1 && form.subids.length > 1"
              @delete="popSubIds"
            />
          </div>
          <div class="mb-16 col-6 !tw-flex !tw-items-end col-6__add-subid">
            <button
              :disabled="form.subids.length >= 5 || targetId === ''"
              class="btn btn-block btn-outline-primary btn-sm mb-0"
              @click.prevent="form.subids.length < 5 && addSubId()"
            >
              + {{ $t('promoCodes.addPromocodes.addAnotherSubid') }}
            </button>
          </div>
        </div>

        <hr>
        <div class="row">
          <div class="col-md-12 col-12 textarea__track">
            <div class="textarea__wrap-title">
              <h6
                v-if="type === 'landing'"
                class="textarea__track-title mb-14"
              >
                {{ $t('mediaTags.redirectUrl') }}
              </h6>
              <h6
                v-if="type === 'html5_banner'"
                class="textarea__track-title mb-14"
              >
                {{ $t('mediaTags.htmlCode') }}
              </h6>
            </div>
            <div style="position: relative">
              <Copytext
                v-model:text="url"
                :button="button"
                :success="$t('offer.card.btnDone')"
                :disabled="warningOpen"
              >
                <template v-slot:btnRight>
                  <a
                    v-if="type === 'landing' && url"
                    :href="url"
                    target="_blank"
                    class="card__btn-arrow btn btn-outline-primary btn-sm mb-4 mt-4"
                  >
                    {{ $t('mediaTags.preview') }}
                    <span class="card__triangle" />
                  </a>
                  <a
                    v-if="type === 'html5_banner' && url"
                    class="card__btn-arrow btn btn-outline-primary btn-sm mb-4 mt-4"
                    @click="mediaPreview(url)"
                  >
                    {{ $t('mediaTags.preview') }}
                    <span class="card__triangle" />
                  </a>
                </template>
              </Copytext>
            </div>
          </div>
        </div>
      </div>

      <template v-slot:footer>
        <button
          class="btn btn-outline-primary btn-sm btn-close-modal"
          @click="close"
        >
          {{ $t('offer.offerRequestSuccess.close') }}
        </button>
      </template>
    </Modal>
    <MediaPreview
      ref="mediaPreview"
      @close-banner="cBanner"
      @open-banner="oBanner"
    />
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { Modal } from '@/components';
import Copytext from '@/components/Copytext';
import { debounce } from '@/lib/lodash';
import MediaPreview from './MediaPreview.vue';

export default {
  components: {
    Modal,
    Copytext,
    MediaPreview,
  },
  data() {
    return {
      warningOpen: false,
      langNewArr: [],
      hiddenModal: false,
      params_id: '',
      active: false,
      offers: [],
      offer: null,
      links: [],
      form: {
        name: '',
        extid: '',
        promocode: '',
        subids: [{ value: '' }],
      },
      link: '',
      targetId: '',
      traffic: 'Value',
      size: null,
      language: '',
      url: '',
      button: 'Copy Tag',
      traffic_source_id: '',
      oldTSid: '',
      checkChange: false,
      brand: '',
      brands: [],
      customSubids: [{ value: '' }],
      locale: '',
      rotation: '',
      type: '',
      paramsSubsId: {},
      getUrlD: debounce(this.getUrl, 800),
      site_page: null,
    };
  },
  computed: {
    ...mapState({
      marketingCampaigns: (state) => state.mediaBuying.marketingCampaigns,
    }),

    params() {
      if (this.type === 'landing') {
        return {
          affiliate_offer_id: this.offer,
          landing_id: this.targetId,
          traffic_source_id: this.traffic_source_id,
          media_buying_campaign_id: undefined,
          marketing_campaign_id: this.rotation,
          site_page: this.site_page,
          language_code: this.language,
          ...this.paramsSubsId,
        };
      }
      return {
        affiliate_offer_id: this.offer,
        landing_id: this.targetId,
        size: this.size,
        marketing_campaign_id: this.rotation,
        media_buying_campaign_id: undefined,
        traffic_source_id: this.traffic_source_id,
        site_page: this.site_page,
        language_code: this.language,
        ...this.paramsSubsId,
      };
    },

    rotations() {
      return this.$_.cloneDeep(this.marketingCampaigns)
        .sort(
          (a, b) => {
            if (a.type) {
              return a.type.length - b.type.length;
            }
          },
        )
        .map((e) => ({
          id: e.id,
          text: e.name,
        }));
    },

    trafficSource() {
      let data = this.$store.state.trafficSource.list.map((e) => {
        return {
          id: e.data.id,
          text: e.name,
        };
      });
      return [{ id: '', text: this.$t('offerRequest.noTrafficSources') }].concat(data);
    },

    languages() {
      const dictionary = this.$store.state.misc.languages;
      return (this.$store.state.media.mediacontent.language_codes || []).map((e) => ({
        id: e,
        text: dictionary.find((f) => f.code == e.toLowerCase()).name,
      }));
    },

    sizes() {
      return this.$store.state.media.mediacontent.sizes
        ? this.$store.state.media.mediacontent.sizes.map((e) => ({
          id: e,
          text: e,
        }))
        : [];
    },

    urls() {
      return this.$store.state.mediaBuying.landings.map((e) => ({
        ...e,
        text: e.name,
      }));
    },

    calcSubIdInTrafficSource() {
      const id = this.traffic_source_id;
      if (!id) return 1;

      const subidArray = Array(5).fill(null).map((el, i) => `subid${i + 1}`);

      const targetTrafficSoutce = this.$store.state.trafficSource.list
        .find((ts) => ts.data.id === id);

      let resultCount = 1;
      subidArray.forEach((el, i) => {
        if (targetTrafficSoutce[el] !== null) {
          resultCount = i + 1;
        }
      });

      return resultCount;
    },
  },
  watch: {
    brand: {
      handler(data) {
        if (data) {
          this.$api.getFinalPages(data).then((res) => {
            this.links = res.payload.site_final_page_urls;
          });
        } else {
          this.links = [];
        }
      },
    },
    traffic_source_id(value, oldValue) {
      if (this.checkChange) return;
      this.oldTSid = oldValue;

      let oldSource = this.$store.state.trafficSource.list.filter((e) => e.data.id === oldValue)[0];
      oldSource = this.$_.pick(oldSource, ['subid1', 'subid2', 'subid3', 'subid4', 'subid5']);
      const subids = {};

      if (!value) {
        for (let i = 0; i < 5; i++) {
          const key = `subid${i + 1}`;
          subids[key] = this.form.subids[i] ? this.form.subids[i].value : null;
        }
        if (!this.$_.isEmpty(oldSource) && !this.$_.isEqual(subids, oldSource)) {
          this.addSubids(subids);
          return;
        }

        if (this.customSubids.some((e) => e.value)) {
          this.form.subids = this.customSubids;
        } else {
          // if no traffic source selected clear subids
          this.form.subids = [{ value: null }];
        }
        return;
      }

      let source = this.$store.state.trafficSource.list.filter((e) => e.data.id === value)[0];
      this.form.extid = source.data.extid || '';
      source = this.$_.pick(source, ['subid1', 'subid2', 'subid3', 'subid4', 'subid5']);
      // if no traffic source selected, like from start
      if (!oldValue) {
        if (this.form.subids === 1 || !this.form.subids[0].value) {
          // if subids empty
          this.addSubids(source);
        } else {
          // take current subids
          const subids = {};
          for (let i = 0; i < 5; i++) {
            const key = `subid${i + 1}`;
            subids[key] = this.form.subids[i] ? this.form.subids[i].value : null;
          }
          // test if current subids is equal with new subids
          if (this.$_.isEqual(subids, source)) {
            this.form.subids = [{ value: null }];
            this.addSubids(source);
          } else {
            // show warning
            this.warningOpen = true;
          }
        }
        return;
      }

      // take current subids, if traffic source selected
      for (let i = 0; i < 5; i++) {
        const key = `subid${i + 1}`;
        subids[key] = this.form.subids[i] ? this.form.subids[i].value : null;
      }
      // test if current subids is equal with old subids
      if (this.$_.isEqual(subids, oldSource)) {
        this.form.subids = [{ value: null }];
        this.addSubids(source);
      } else {
        // show warning
        this.warningOpen = true;
      }
    },
    //
    // locale() {
    //   this.brands[0].text = this.$t('profile.generalInfo.notSpecified');
    // },

    'form.subids': {
      handler(subids) {
        this.parseSubids(subids);
      },
      deep: true,
    },
  },
  activated() {
    this.$store.dispatch('getLanguagesLazy');
    // vue3-migration -- падал с ошибкой
    // this.getMarketingMedias();
    this.getMarketingMedias([]);
  },
  updated() {
    // здесь возникает ошибка при разлогиникании - '_t'
    this.type == 'landing' ? (this.button = this.$t('offer.card.btn')) : (this.button = this.$t('offer.card.btnCode'));
    this.locale = this.$locale.value;
  },

  methods: {
    hideSelect(options = [], name = '') {
      if(name === 'brand') {
        return options.length > 2;
      }
      return options.length > 1;
    },

    setSize() {
      if (this.type === 'html5_banner' || this.type === 'simple_banner') {
        this.size = this.sizes[0].id;
      }
    },

    handlerLanguage() {
      this.getUrl();
    },

    handlerSizes() {
      this.getUrl();
    },

    inputLink() {
      this.site_page = this.link;
      this.getUrlD();
    },

    setLink(url) {
      this.link = url;
      this.site_page = url;
      this.getUrl();
    },

    parseSubids(subids) {
      if (this.targetId !== '') {
        const objSubs = {};
        for (let i = 0; i < subids.length; i++) {
          const key = `subid${i + 1}`;
          objSubs[key] = subids[i] ? subids[i].value : null;
        }

        this.paramsSubsId = objSubs;
        this.getUrlD();
      }
    },

    async changeRotation(v) {
      if (v === '') {
        this.resetForTarget();
        this.targetId = '';
        return;
      }
      if (this.targetId) {
        await this.getUrl();
      }
    },

    selectOffer(v) {
      this.resetForTarget();
      this.rotation = '';
      if (v === '') {
        this.brand = '';
        return;
      }
      // reseting form
      this.brand = '';

      const brandsPm = this.$store.state.media.mediacontent.visible_brands.map((i) => i.site_id);
      const brands = this.offers
        .find((e) => e.id === this.offer)
        .visible_brands.filter((e) => brandsPm.includes(e.site_id))
        .map((e) => ({
          id: e.site_id,
          text: e.site_name,
        }));

      this.brands = [
        {
          id: '',
          text: this.$t('profile.generalInfo.notSpecified'),
        },
      ].concat(brands);

      if (brands.length === 1) {
        this.brand = brands[0].id;
        this.changeBrand();
      }
    },

    async changeBrand() {
      this.resetForTarget();
      if (this.brand === '') {
        this.rotation = '';
        return;
      }

      await this.$store.dispatch('getLandings', { site_id: this.brand });
      this.rotation = this.rotations[0].id;
      if (this.urls.length === 1) {
        this.targetId = this.urls[0].id;
        this.selectTarget();
      }
    },

    selectTarget() {
      if (this.targetId === '') {
        this.resetForTarget();
        return;
      }

      this.getUrl();
    },

    async getUrl() {
      if (this.type === 'landing') {
        const {
          payload: { url },
        } = await this.$api.getMarketingMaterialLandingUrl(this.params_id, this.params);
        this.url = url;
        return;
      }

      const {
        payload: { script },
      } = await this.$api.getMarketingMaterialBannerScript(this.params_id, this.params);
      this.url = script;
    },

    getMarketingMedias(visible_brands = [], sub_affiliate_id) {
      return this.$api
        .getAffiliateOffers({
          sub_affiliate_id,
        })
        .then((res) => {
          const brandsPm = visible_brands.map((i) => i.site_id);
          Promise.all(res.payload.map((offer) => this.$api.getAffiliateOffer(offer.id, { sub_affiliate_id }).then(
            (res) => ({
              name: offer.name,
              text: offer.name,
              id: offer.id,
              visible_brands: res.payload.visible_brands,
            }),
          ))).then((res) => {
            this.offers = [
              ...res.filter((e) => e.visible_brands.filter((i) => brandsPm.includes(i.site_id)).length),
            ];
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },

    async open({ id, type, visible_brands, sub_affiliate_id }) {
      // эти же бренды приходят и в запросе getMediaContent в стор
      this.reset();
      this.type = type;
      this.params_id = id;
      await this.getMarketingMedias(visible_brands, sub_affiliate_id);
      await this.$store.dispatch('getTrafficSources', {
        sub_affiliate_id,
      });
      await this.$store.dispatch('getMediaContent', this.params_id);
      this.active = true;
      this.setSize();
      this.countryFilter();
      if (this.offers.length === 1) {
        this.offer = this.offers.filter((f) => f.id)[0].id;
        this.selectOffer(this.offer);
      }
    },

    close() {
      this.reset();
      this.active = false;
    },

    reset() {
      this.traffic_source_id = null;
      this.form.extid = '';
      this.offer = '';
      this.brand = '';
      this.rotation = '';
      this.link = '';
      this.links = [];
      this.site_page = '';
      this.targetId = '';
      this.size = '';
      this.form.subids = [{ value: null }];
      this.customSubids = [{ value: null }];
      this.strLang = '';
      this.url = '';
      this.language = '';
      this.paramsSubsId = {};
      this.checkChange = false;
      this.warningOpen = false;
    },
    resetForTarget() {
      this.traffic_source_id = null;
      this.form.extid = '';
      this.link = '';
      this.targetId = '';
      this.form.subids = [{ value: null }];
      this.customSubids = [{ value: null }];
      this.paramsSubsId = {};
      this.site_page = '';
      this.strLang = '';
      this.url = '';
      this.language = '';
      this.checkChange = false;
      this.warningOpen = false;
    },

    mediaPreview(item) {
      this.$refs.mediaPreview.open(item);
    },
    cBanner(v) {
      this.hiddenModal = false;
    },

    oBanner(v) {
      this.hiddenModal = v;
    },

    addSubId() {
      this.form.subids.push({
        value: '',
      });
    },
    popSubIds(item) {
      this.form.subids.pop();
    },

    addSubids(source) {
      if (!source) {
        this.form.subids = [{ value: null }];
        return;
      }
      this.form.subids = [];
      // Push subids
      Object.keys(source).map((k) => {
        if (k.startsWith('subid')) {
          const subid_index = parseInt(k.replace('subid', '')) - 1;
          if (source[k]) {
            this.form.subids.push({
              value: source[k],
            });
          } else {
            this.form.subids.push({
              value: null,
            });
          }
        }
      });
      // reduce subids
      for (let i = this.form.subids.length - 1; i >= 1; i--) {
        if (!this.form.subids[i].value) this.form.subids.pop();
        else break;
      }
    },

    confirmChanges() {
      this.form.subids = [{ value: null }];
      this.customSubids = [{ value: null }];
      const source = this.$store.state.trafficSource.list.filter((e) => e.data.id === this.traffic_source_id)[0];
      this.addSubids(source);
    },

    saveSubids() {
      if (this.form.subids.length < this.calcSubIdInTrafficSource) {
        const remainder = this.calcSubIdInTrafficSource - this.form.subids.length;

        this.customSubids = [
          ...this.$_.cloneDeep(this.form.subids),
          ...Array(remainder).fill({ value: '' }),
        ].map((el) => (!el.value ? { value: '' } : el));
        this.form.subids = this.customSubids;
      } else {
        this.customSubids = this.$_.cloneDeep(this.form.subids);
      }

      this.checkChange = true;
      this.warningOpen = false;
    },

    countryFilter() {
      for (let i = 0; i < this.$store.state.media.mediacontent.language_codes.length; i++) {
        for (let j = 0; j < this.$store.state.misc.languages.length; j++) {
          if (
            this.$store.state.media.mediacontent.language_codes[i].toLowerCase() 
              === this.$store.state.misc.languages[j].code
          ) {
            this.langNewArr.push(this.$store.state.misc.languages[j]);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
// дубликатов нет
@import 'src/assets/theme/default/media/mediatags';
</style>
